export default __webpack_public_path__ + "static/media/Inter-UI-BoldItalic.919884cf.woff";